import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { TimeRangeFilter } from '../../filters';
import { UiPerformanceTestLogPanel } from '../../panels';

export const pageId = 'ui-performance';

export default function UiPerformancePage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`UI Performance`}>
                <FilterContainer>
                    <TimeRangeFilter required options={{ realTime: true }} />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <UiPerformanceTestLogPanel flexHeight />
            </PanelContainer>
        </Page>
    );
}
